import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { IClaimFormDisabilityType, IClaimFormDisabilityTypeState } from './ClaimFormDisabilityTypes';
import { IChildrenProps } from 'types/children';

const initialState: IClaimFormDisabilityType = {
    borrowerComments: '',
    borrowerContactPreference: '',
    borrowerDateOfBirth: '',
    borrowerEmail: '',
    borrowerMailingAddress: '',
    borrowerMailingAddress2: '',
    borrowerMailingCity: '',
    borrowerMailingState: undefined,
    borrowerMailingZip: '',
    borrowerNameFirst: '',
    borrowerNameLast: '',
    borrowerNameMiddle: '',
    borrowerPhone: '',
    borrowerSSN: '',
    borrowerSuffix: undefined,
    disabilityCategory: '',
    disabilityDateExpectedWorking: '',
    disabilityDateLastWorked: '',
    disabilityDateOfIncident: '',
    disabilityExplanationOf: '',
    disabilityFiledOnBehalfOf: undefined,
    disabilityFirstPhysicianDate: '',
    disabilityHealthcareAddress: '',
    disabilityHealthcareCity: '',
    disabilityHealthcareContactNumber: '',
    disabilityHealthcareHospitalName: '',
    disabilityHealthcareName: '',
    disabilityHealthcareState: undefined,
    disabilityHealthcareZip: '',
    disabilityJobDuties: '',
    disabilityKnowWhenExpectedWorking: '',
    disabilityTypeOfSurgery: '',
    eDeliveryConfirmation: '',
    employerAddress: '',
    employerCity: '',
    employerContactNumber: '',
    employerEmail: '',
    employerName: '',
    employerState: undefined,
    employerZip: '',
    submitterCompanyName: '',
    submitterEmail: '',
    submitterNameFirst: '',
    submitterNameLast: '',
    submitterPhone: ''
};

export const ClaimFormDisabilityContext = React.createContext<IClaimFormDisabilityTypeState | null>(null);

const ClaimFormDisabilityProvider: React.FC<IChildrenProps> = ({ children }) => {
    const [stateClaimFormDisability, setStateClaimFormDisability] = useState<IClaimFormDisabilityType>(initialState);
    const updateContextStateClaimFormDisability = useCallback((formData: IClaimFormDisabilityType): void => {
        setStateClaimFormDisability(formData);
    }, []);
    const updatePartialContextStateClaimFormDisability = useCallback(
        (partialFormData: Partial<IClaimFormDisabilityType>): void => {
            setStateClaimFormDisability((prevState) => ({
                ...prevState,
                ...partialFormData
            }));
        },
        []
    );
    const reinitialiseStateClaimFormDisability = useCallback((): void => {
        setStateClaimFormDisability(initialState);
    }, []);
    const stateObject = useMemo<IClaimFormDisabilityTypeState>(
        () => ({
            contextStateClaimFormDisability: stateClaimFormDisability,
            updateContextStateClaimFormDisability,
            updatePartialContextStateClaimFormDisability,
            reinitialiseStateClaimFormDisability
        }),
        [
            stateClaimFormDisability,
            updateContextStateClaimFormDisability,
            updatePartialContextStateClaimFormDisability,
            reinitialiseStateClaimFormDisability
        ]
    );

    return <ClaimFormDisabilityContext.Provider value={stateObject}>{children}</ClaimFormDisabilityContext.Provider>;
};

export default ClaimFormDisabilityProvider;
